import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import AllergyEditPage from "../allergies/allergy-edit/allergy-edit";
import { AllergiesPage } from "./allergies";

@NgModule({
  entryComponents: [AllergyEditPage],
  declarations: [AllergiesPage, AllergyEditPage],
  imports: [
    IonicPageModule.forChild(AllergiesPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
  ],
})
export class AllergiesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/allergies/allergies.module.ts